import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { NextReviewPeriodRequestButtonComponent } from './next-review-period-request-button/next-review-period-request-button.component';
import { NextReviewPeriodRequestDialogComponent } from './next-review-period-request-dialog/next-review-period-request-dialog.component';
import { PrimeNgModule } from '@shared/prime-ng/prime-ng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '@shared/pipe/pipe.module';

@NgModule({
  declarations: [
    NextReviewPeriodRequestButtonComponent,
    NextReviewPeriodRequestDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PrimeNgModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [NextReviewPeriodRequestButtonComponent],
})
export class NextReviewPeriodRequestModule {}
